import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
} from '@mui/material';
import { SelectInputProps } from './types';

const SelectInput = ({
  id,
  label,
  name,
  options,
  value,
  onChange,
  errorMsg,
  isValid = true,
}: SelectInputProps ) => (
  <div key={id}>
    <FormControl variant="filled" fullWidth>
      <InputLabel id={`${id}-label`} htmlFor={id}>{label}</InputLabel>
      <Select
        id={id}
        native
        labelId={`${id}-label`}
        name={name}
        label={label}
        onChange={(eventParam) => {
          onChange(eventParam);
        }}
        value={value}
        error={!isValid}
        inputProps={{
          'data-testid': 'select-select'
        }}
        IconComponent={ExpandMoreIcon}
      >
        {options.map(({ value: v, label: l, disabled: d }) => (
          <option value={v} key={l} disabled={d}>
            {l}
          </option>
        ))}
      </Select>
      {(!isValid || errorMsg) &&
        <FormHelperText data-testid="errorMessage">
          {errorMsg}
        </FormHelperText>
      }
    </FormControl>
  </div>
);

export default SelectInput;
